import development from './configuration/constants-development';
import production from './configuration/constants-production';
import staging from './configuration/constants-staging';
import storybook from './configuration/constants-storybook';
import test from './configuration/constants-test';

function getAppSettings(): IAppSettings {
    if (import.meta.env.STORYBOOK) {
        return storybook;
    }

    // NOTE: The bundler (Vite) injects the proper APP_SETTINGS at build time
    // and removes the unused configurations during optimization.

    if (import.meta.env.MODE === 'development') {
        return development;
    }

    if (import.meta.env.MODE === 'production') {
        return production;
    }

    if (import.meta.env.MODE === 'staging') {
        return staging;
    }

    if (import.meta.env.MODE === 'test') {
        return test;
    }

    return development;
}

const AppSettings = getAppSettings();

export default AppSettings;

interface IAppSettings {
    VERSION: string;
    ENV: string;
    SENTRY_DSN: string;
    googleAnalyticsId: string;
    googleApiURLKey: string;
    routes: {
        api: string;
        gateway: string;
    };
    launchDarklyClientSideId: string;
    closelinkChartsUrl: string;
    auth0: {
        domain: string;
        clientId: string;
        audience: string;
        cookieDomain: string | undefined;
    };
    survicateWorkspaceKey: string;
    survicateSurveyId: {
        customer: string;
        supplier: string;
    };
    approvalTokenEncryptionKey: string;
}
